// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1VO7v","label":"CategoryService_label__1yAYK","location":"CategoryService_location__27_qS"};